import React from 'react';
import { Icon } from '@/shared/icons'
interface ActivityBadgeProps {
  count: number;
  onClick?: () => void;
  isActive?: boolean;
}

/**
 * Activity badge icon with pending count
 * Used in the application header for activities dropdown
 */
export const ActivityBadge: React.FC<ActivityBadgeProps> = ({
  count,
  onClick,
  isActive = false
}) => {
  return (
    <button
      onClick={onClick}
      className="relative w-[32px] h-[32px] flex items-center justify-center rounded-lg transition-colors"
      style={{
        backgroundColor: isActive ? 'rgba(148,163,184,0.14)' : 'transparent',
        // Rodapé da sidebar: uniformizar com os demais ícones utilitários
        // (sidebar-text, cinza-azulado) em vez do quase-branco do header.
        color: 'var(--theme-sidebar-text)'
      }}
      onMouseEnter={(e) => {
        if (!isActive) {
          e.currentTarget.style.backgroundColor = 'rgba(148,163,184,0.14)';
        }
      }}
      onMouseLeave={(e) => {
        if (!isActive) {
          e.currentTarget.style.backgroundColor = 'transparent';
        }
      }}
    >
      <Icon name="activity" className="w-[18px] h-[18px]" />

      {/* `.util .badge` do mockup: 16px, 9px bold, top/right -2 (laranja = atividades) */}
      {count > 0 && (
        <span
          className="absolute flex items-center justify-center font-bold text-white rounded-full"
          style={{
            top: -2, right: -2, minWidth: 16, height: 16,
            padding: '0 4px', fontSize: 9, lineHeight: 1,
            backgroundColor: '#f97316',
          }}
        >
          {count > 99 ? '99+' : count}
        </span>
      )}
    </button>
  );
};
